import { logoColourMap, LogoProps, LogoSize, LogoVariant } from './logo.types';
const LogoXemploMark = ({ variant, size }: LogoProps) => (
  <svg
    data-testid="logo-xemplo-mark"
    height={size ?? LogoSize.m}
    viewBox="0 0 84 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.196 22.416 77.94 7.353l.044-.067L83.172 0H62.308l-1.38 1.944-8.105 11.376-.056.078-1.87 2.626 1.87 2.626.056.078 3.262 4.57 1.48 2.068c.902 1.263 2.227 1.944 3.764 1.944 1.536 0 2.872-.681 3.763-1.944l2.104-2.961v.01ZM50.897 55.982l1.87 2.625.056.079 8.105 11.37L62.308 72h20.864l-5.243-7.35-10.622-14.9-2.215-3.117c-.902-1.262-2.227-1.943-3.764-1.943-1.536 0-2.872.681-3.763 1.943l-1.447 2.033-3.284 4.613-.056.078-1.87 2.625h-.011ZM58.345 36 32.368 72H11.184l25.977-36L11.173 0h21.195l25.977 36Z"
      fill={logoColourMap[variant ?? LogoVariant.default]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.793 36 15.862 55.862H0L13.931 36 0 16.138h15.862L29.793 36Z"
      fill={logoColourMap[variant ?? LogoVariant.default]}
    />
  </svg>
);
export default LogoXemploMark;
